import { memo } from 'react';

import { Note } from '@/types/note';
import Card from '@/ui/components/Card';
import DualTime from '@/ui/components/DualTime';
import formatStaffName from '@/utils/formatStaffName';

import NoteBody from '../NoteBody';

interface NoteCardProps {
  note: Note;
}

const NoteCard = ({ note }: NoteCardProps) => {
  if (!note?.body) return null;

  return (
    <Card>
      <NoteBody note={note} />

      {note?.author && (
        <p className="text-xs text-gray-500">
          {note?.note_type && <span className="mr-1">{note?.note_type?.title},</span>}
          Created <DualTime dateTime={new Date(note.created_at)} />
          <span> by {formatStaffName({ staff: note.author })}</span>
        </p>
      )}
    </Card>
  );
};

export default memo(NoteCard);
